var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7952 17.5C7.38281 18.0186 8.15468 18.3333 9.00006 18.3333C9.84543 18.3333 10.6173 18.0186 11.2049 17.5M14.0001 6.66663C14.0001 5.34054 13.4733 4.06877 12.5356 3.13109C11.5979 2.19341 10.3261 1.66663 9.00006 1.66663C7.67397 1.66663 6.4022 2.19341 5.46452 3.13109C4.52684 4.06877 4.00006 5.34054 4.00006 6.66663C4.00006 9.24178 3.35045 11.0049 2.62478 12.1711C2.01266 13.1549 1.7066 13.6467 1.71783 13.7839C1.73025 13.9359 1.76244 13.9938 1.88487 14.0846C1.99544 14.1666 2.49388 14.1666 3.49077 14.1666H14.5093C15.5062 14.1666 16.0047 14.1666 16.1152 14.0846C16.2377 13.9938 16.2699 13.9359 16.2823 13.7839C16.2935 13.6467 15.9875 13.1549 15.3753 12.1711C14.6497 11.0049 14.0001 9.24178 14.0001 6.66663Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.81120789d0334b44c136a18dec67bda6.svg";
export { ForwardRef as ReactComponent };